function ChangeBadge({ change }) {
  if (change == null) return null;
  const positive = change >= 0;
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[11px] font-bold ${
        positive
          ? "bg-palette-emerald-soft text-palette-emerald-hover"
          : "bg-palette-red-soft text-palette-red-badge"
      }`}
    >
      {positive ? "▲" : "▼"}
      {Math.abs(change).toFixed(1)}%
    </span>
  );
}

/**
 * Props:
 *   label       string
 *   value       string | number
 *   change      number | null   — percentage (positive = up, negative = down); renders ▲/▼ badge
 *   tag         string | null   — small pill shown below the value
 *   valueClass  string          — Tailwind color class for the value text
 */
export default function SummaryCard({
  label,
  value,
  change = null,
  tag = null,
  valueClass = "text-palette-gray-primary",
}) {
  return (
    <div className="flex-1 min-w-[160px] bg-white rounded-2xl border border-palette-gray-divider px-5 py-4 shadow-sm">
      <div className="text-[11px] font-semibold uppercase tracking-widest text-palette-gray-secondary mb-2">
        {label}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`text-2xl font-extrabold leading-tight tabular-nums ${valueClass}`}>
          {value}
        </span>
        <ChangeBadge change={change} />
      </div>
      {tag && (
        <div className="mt-1.5 inline-flex items-center rounded-full bg-palette-gray-subtle border border-palette-gray-divider px-2.5 py-0.5 text-xs text-palette-gray-secondary">
          {tag}
        </div>
      )}
    </div>
  );
}
